module.exports = __webpack_public_path__ + "static/media/audit-trail-logo.ff4b611b.png";